var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcr-filter-bar"},[_c('div',{staticClass:"vcr-filter-bar__title"},[_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"vcr-filter-bar__filters"},[_vm._t("filters")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }